export var BackgroundColorOptions = {
  Light: 'light',
  White: 'white',
  Default: 'default'
};
export var BorderOptions = {
  None: 'none',
  Regular: 'regular',
  Dashed: 'dashed'
};
//# sourceMappingURL=Container.types.js.map